<script setup lang="ts">
definePageMeta({
  key: 'sports-page',
});

const { $containment } = useNuxtApp();
const { isAuthenticated } = storeToRefs(useAuthStore());

watch(
  isAuthenticated,
  async () => {
    if (!isAuthenticated.value) {
      return;
    }

    const { isValidationModuleEnabled } = useModulesValidation();

    if (isValidationModuleEnabled('sports')) {
      await $containment.fetchCurrentPending('sports');

      if ($containment.hasPendencyOn('sports')) {
        $containment.closeVerificationModal();

        // Usa localeLink (helper puro) em vez de $localePath via
        // useNuxtApp() dentro de watch async — o contexto Nuxt se perde
        // entre re-runs do watcher, deixando $localePath como undefined
        // e quebrando com "TypeError: e is not a function".
        return await navigateTo(localeLink('/'));
      }
    }
  },
  { immediate: true },
);
</script>

<template>
  <PagesSports />
</template>
